import { createRouter, createWebHistory } from "vue-router";
// import Dashboard from "../views/Dashboard.vue";
import Signin from "../views/Signin.vue";
import ProductsTable from "../views/ProductsTable.vue";
import ClientsTableNew from "../views/ClientsTableNew.vue";
import SalesTable from "../views/SalesTable.vue";
import BlackList from "../views/BlackList.vue";
import RepairTable from "../views/RepairTable.vue";
import Discount from "@/views/Discount.vue";
import OrdersTable from "@/views/OrdersTable.vue";

const routes = [
  // {
  //   path: "/",
  //   name: "Главная",
  //   component: Dashboard,
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/products",
    name: "Товары",
    component: ProductsTable,
    meta: { requiresAuth: true },
  },
  {
    path: "/clients",
    name: "Клиенты",
    component: ClientsTableNew,
    meta: { requiresAuth: true },
  },
  {
    path: "/sales",
    name: "Продажи",
    component: SalesTable,
    meta: { requiresAuth: true },
  },
  {
    path: "/black-list",
    name: "Черный список",
    component: BlackList,
    meta: { requiresAuth: true },
  },
  {
    path: "/repair",
    name: "Ремонт",
    component: RepairTable,
    meta: { requiresAuth: true },
  },
  {
    path: "/discount",
    name: "Скидки",
    component: Discount,
    meta: { requiresAuth: true },
  },
  {
    path: "/",
    name: "Заказы",
    component: OrdersTable,
    meta: { requiresAuth: true },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});


router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !localStorage.getItem("token")) {
    next({ name: "Signin" });
  } else {
    next();
  }
});



export default router;
